import { baseConfig, RuntimeConfig } from 'config/config.types';

export const config: RuntimeConfig = {
  ...baseConfig,
  env: 'pcm-prd2',
  gravityEnabledByDefault: true,
};
